import React from "react";

export const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const isSuccess = status?.toLowerCase() === "success";
  return (
    <span
      className={`rounded-sm px-3 py-0.5 text-tiny font-semibold ${
        isSuccess
          ? "bg-[#E6F3F0] text-[#005D49]"
          : "bg-[#FFE8E8] text-[#CC0300]"
      }`}
    >
      {status || "--"}
    </span>
  );
};

export const SubstitutionStatus: React.FC<{ allowed: boolean }> = ({
  allowed,
}) => (
  <div className="border-t border-primaryGray-15 pt-4">
    <div className="mb-1 text-tiny font-normal text-primaryGray-3">
      Substitution Status
    </div>
    <div className="flex items-center gap-1.5 text-tiny font-bold text-primaryGray-1">
      <span
        className={`inline-block h-2.5 w-2.5 rounded-full ${
          allowed ? "bg-[#00B389]" : "bg-[#CC0300]"
        }`}
      />
      {allowed ? "Allowed" : "Not Allowed"}
    </div>
  </div>
);

export const DecisionReasonBar: React.FC<{ reason: string }> = ({ reason }) => (
  <div className="mb-4 rounded-lg border-[#EFF6FF] bg-[#ddecff] px-4 py-3 text-tiny font-normal text-primaryGray-1">
    {reason || "--"}
  </div>
);
